export const { TOKEN_RDSTATION, URL_RDSTATION, IDCONVERSAO_ESPECIFICO } =
  window.options || {};

export const CF_INTERESSE = '190461';
export const CF_PARCELA = '1022331';
